<app-label-inflator
  #labelCalculator
  hidden
  class="print-card-label"
  [columnLabel]="false"
  [labelComponentInterface]="data"
  [reset]="false">
</app-label-inflator>

<div class="main-content">
  <div class="brand-name-and-label-container">
    <div class="product-card-badge-outer">
      <div
        *ngIf="(data?.menu | printCardMenuBasicMethod: 'getNumberOfBadgesForVariant' : data) > 0"
        class="product-card-badge-inner">
        <img
          *ngFor="let variantBadge of data | printCardBadges"
          appImage
          class="product-card-badge"
          [asset]="variantBadge?.image"
          alt="badge"
          src="" />
      </div>
    </div>
    <div class="brand-name-and-label">
      <div class="brand-name">
        <div class="brand-and-name" [style.color]="viewModel.headerTextColor$ | async">
          <div
            *ngIf="data | sectionRowViewModelBasicMethod: 'getBrand' as brand"
            appPrintCardScaleDownText
            [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
            [adjustLineHeight]="false"
            [maxWidthInPx]="272"
            [maxHeightInPx]="36"
            class="product-card-brand">
            {{ brand | trimSafely }}
          </div>
          <div
            *ngIf="data | sectionRowViewModelBasicMethod: 'getRowTitle' as title"
            appPrintCardScaleDownText
            [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
            [adjustLineHeight]="false"
            [maxWidthInPx]="272"
            [maxHeightInPx]="64"
            class="product-card-name">
            {{ title | trimSafely }}
          </div>
        </div>
      </div>
      <app-label-inflator
        class="print-card-label"
        [columnLabel]="false"
        [labelComponentInterface]="data"
        [reset]="false">
      </app-label-inflator>
    </div>
  </div>
  <div class="type-and-price-container">
    <div class="type-and-price">
      <div
        *ngIf="!(viewModel.isAccessory$ | async) && !(viewModel.isNonCannabinoidOtherVariant$ | async)"
        class="product-card-type"
        [style.color]="viewModel.bodyTextColor$ | async">
        <ng-container
          *rxLet="
            viewModel
              | getExpandedGridSize: (viewModel.spoofedColViewModel$ | async) : true : false : false
              | async as size
          ">
          {{ (size | stringIncludes: 'capsule' : true) ? (size | replace: ' Capsule(s)*' : '') : size }}
          <ng-container *rxLet="viewModel.variantType$ | async as variantType">
            {{ (size | stringIncludes: 'capsule' : true) ? (size | replace: '\\d* ' : '') : variantType }}
          </ng-container>
        </ng-container>
      </div>
      <div class="product-card-price" [style.color]="viewModel.bodyTextColor$ | async">
        <app-column-primary-price
          [menu]="viewModel.cardStackMenu$ | async"
          [section]="viewModel.cardStack$ | async"
          [colVm]="viewModel.spoofedColViewModel$ | async"
          [rowVm]="viewModel.cardData$ | async"
          [locConfig]="viewModel.locationConfig$ | async"
          [locationId]="viewModel.locationId$ | async"
          [productStylingVm]="viewModel">
        </app-column-primary-price>
      </div>
    </div>
  </div>
</div>
<div class="color-strip" [style.color]="viewModel.bodyTextColor$ | async">
  <div
    *ngIf="
      !(viewModel.isNonCannabinoidOtherVariant$ | async) &&
      (data | sectionRowViewModelBasicMethod: 'getReadableStrainType') as strainType
    "
    class="property-container">
    <div class="title">Strain</div>
    <div
      appPrintCardScaleDownText
      [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
      [adjustLineHeight]="false"
      [maxWidthInPx]="148"
      [maxHeightInPx]="28"
      class="value">
      {{ strainType }}
    </div>
  </div>
  <div *ngFor="let data of viewModel.propertiesBasedOnPools$ | async" class="property-container">
    <div class="title">{{ data?.title }}</div>
    <div appPrintCardScaleDownText [maxWidthInPx]="148" [maxHeightInPx]="28" class="value">
      {{ data?.value }}
    </div>
  </div>
</div>
